// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages-table {
  max-width: 550px;
  max-height: 400px;
  overflow-y: auto;
}
.messages-table div {
  border: 1px solid #ddd !important;
  border-bottom: none !important;
  padding: 15px 20px;
  display: flex;
}
.messages-table div:last-child {
  border-bottom: 1px solid #ddd !important;
}
.messages-table div label {
  display: flex;
  gap: 20px;
}
.messages-table div label:hover {
  cursor: pointer;
}

.messages-title {
  justify-content: flex-end;
}
@media screen and (max-width: 750px) {
  .messages-title {
    justify-content: flex-start;
  }
}

@media screen and (max-width: 1050px) {
  .prize-type-cont {
    padding: 0 !important;
  }
}

.notifications-overview {
  max-width: 1200px;
  margin: 0 auto;
}
.notifications-overview .table th {
  white-space: nowrap;
}
.notifications-overview .item-photo {
  vertical-align: middle;
}
.notifications-overview .item-photo img {
  height: auto !important;
}
.notifications-overview .item-wingame {
  vertical-align: middle;
  min-width: 180px;
}
.notifications-overview .item-wingame h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
}
.notifications-overview .item-wingame p {
  margin: 5px 0 0;
  font-size: 14px;
}
.notifications-overview .item-status {
  min-width: 100px;
}

.notifications-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media screen and (max-width: 750px) {
  .notifications-title {
    flex-direction: column-reverse;
    gap: 20px;
    align-items: flex-end;
  }
}
@media screen and (max-width: 1100px) {
  .notifications-title h2 {
    font-size: 23px;
  }
}
@media screen and (max-width: 750px) {
  .notifications-title h2 {
    font-size: 18px;
    width: 100%;
  }
}
@media screen and (max-width: 750px) {
  .notifications-title .submit-btn {
    max-width: 250px;
  }
}

.go-to-statuses-btn {
  position: absolute;
  top: 0;
  right: 0;
}
@media screen and (max-width: 1100px) {
  .go-to-statuses-btn {
    position: relative !important;
    float: right;
  }
}

.table-container {
  min-width: 970px;
  margin: 30px auto 0;
}
@media screen and (max-width: 1025px) {
  .table-container {
    padding: 0 !important;
    padding-top: 20px !important;
    margin: 0 !important;
  }
}
.table-container .not_connected_to_event {
  caret-color: transparent;
  -webkit-user-select: none;
          user-select: none;
}
.table-container .not_connected_to_event:hover {
  cursor: pointer;
}
.table-container .notifications-textarea {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  width: 100%;
}
.table-container .form-title,
.table-container .form-item {
  font-weight: 700;
  font-size: 14px;
  padding-bottom: 20px;
}
.table-container .form-title {
  color: rgb(93, 95, 99);
  width: 250px;
  text-align: right;
  padding-right: 30px;
}
@media screen and (max-width: 750px) {
  .table-container .form-title {
    text-align: left;
  }
}
.table-container .form-item {
  font-weight: 400;
  color: rgb(57, 62, 69);
  padding-right: 250px;
}
@media screen and (max-width: 750px) {
  .table-container .form-item {
    padding-right: 0 !important;
  }
}
.table-container .form-item.field-error > * {
  background: rgba(255, 0, 0, 0.12);
}
.table-container .form-item .upload-type-cont {
  max-width: 550px;
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
}
.table-container .form-item.single-input {
  display: flex;
  align-items: center;
}
.table-container .form-item.date-time-control {
  display: flex;
  gap: 20px;
  font-size: 14px;
}
.table-container .form-item.date-time-control input {
  text-indent: -999px;
  width: 171px;
  height: 36.5px;
}
.table-container .form-item.date-time-control .formatted-date {
  position: absolute;
  padding: 10px;
}
.table-container .form-item.date-time-control .formatted-hour,
.table-container .form-item.date-time-control .formatted-minutes {
  width: 44px;
  height: 36.5px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-container .form-item.date-time-control .formatted-minutes {
  margin-left: 10px;
  position: relative;
}
.table-container .form-item.date-time-control .formatted-minutes:after {
  content: ":";
  position: absolute;
  left: -18px;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 120%;
}
.table-container .form-item.color-picker-cont {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-right: 0;
}
.table-container .form-item.color-picker-cont input.color-picker {
  width: 40px;
  height: 40px;
  text-indent: -999px;
  border-radius: 50%;
}
.table-container .form-item.color-picker-cont .color-picker-input {
  width: 90px;
  height: 40px;
}
.table-container .form-item.color-picker-cont .color-piecker-texts-cont {
  display: flex;
  flex-direction: column;
}
.table-container .form-item.color-picker-cont .color-piecker-texts-cont .color-text-title {
  font-weight: 700;
}
.table-container .form-item.color-picker-cont .color-piecker-texts-cont .color-text-desc {
  font-weight: 400;
}
.table-container .form-item.pb-0 {
  padding-bottom: 0 !important;
}
.table-container .form-item.image-upload-container .upload-type-cont {
  padding: 20px 0 10px;
}
.table-container .form-item.image-upload-container .upload-type-cont.img-preview {
  display: flex;
  overflow-x: hidden;
  align-items: center;
}
.table-container .last-tr-item {
  position: relative;
  height: 20px;
}
.table-container .last-tr-item:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0%;
  width: 100%;
  height: 1px;
  background: rgb(235, 238, 245);
  z-index: 1;
}
.table-container .editor-container .editor-languages-cont {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.wingames-content {
  position: relative;
}
.wingames-content .submit-btn {
  background-color: rgb(249, 0, 71) !important;
  min-width: 229px;
  height: 38px;
  border-radius: 4px;
  color: white;
  border: none;
  font-size: 14px;
  caret-color: transparent;
}
.wingames-content .submit-btn[disabled] {
  pointer-events: none;
  opacity: 0.6;
}
.wingames-content .submit-btn:hover {
  cursor: pointer;
}
.wingames-content .go-to-statuses-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.wingames-content .reset-btn {
  border: none;
  background-color: transparent;
  padding: 0;
}
.wingames-content .reset-btn:hover {
  cursor: pointer;
}

.editor-languages-cont .btn:not(.btn-close) {
  border: none;
  font-size: 14px;
  padding: 8px 22px;
  border-radius: 4px;
  background-color: rgb(193, 193, 193);
  color: black;
}
.editor-languages-cont .btn:not(.btn-close).txt-white {
  color: white;
}
.editor-languages-cont .btn:not(.btn-close).change-activity {
  background-color: rgb(250, 250, 250);
}
.editor-languages-cont .btn:not(.btn-close).active, .editor-languages-cont .btn:not(.btn-close).btn-grey {
  background-color: rgb(193, 193, 193);
}
.editor-languages-cont .btn:not(.btn-close).btn-upload {
  color: white;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
